import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import ReactGA from 'react-ga4';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation } from "react-router";
import '@mantine/core/styles.css';
import { Container, MantineProvider } from '@mantine/core';
import Header from './components/header/Header.tsx';
import About from './pages/about/About.tsx';
import Footer from './components/footer/Footer.tsx';
import { AuthProvider } from './hooks/useAuth.tsx';
import App from './App.tsx';
import AdminDashboard from './pages/adminDashboard/AdminDashboard.tsx';
import { AuthLoader } from './helpers/AuthLoader.tsx';
import PostPage from './pages/post/PostPage.tsx';
import Auth from './pages/auth/Auth.tsx';
import PrivacyPolicy from './pages/legal/PrivacyPolicy.tsx';
import TermsOfUse from './pages/legal/TermsOfUse.tsx';
import './i18n/i18n.ts';
import { trackPageView } from './utils/analytics.ts';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

if (GA_MEASUREMENT_ID) {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID);
}

function AnalyticsListener() {
  const location = useLocation();

  useEffect(() => {
    const page = `${location.pathname}${location.search}`;
    const title =
      typeof document !== 'undefined' && typeof document.title === 'string'
        ? document.title
        : undefined;
    trackPageView(page, title);
  }, [location]);

  return null;
}

root.render(
  <React.StrictMode>
    <MantineProvider
      theme={{
        primaryColor: 'brand',
        colors: {
          brand: [
            '#e6f2ef', // 0 (lightest)
            '#cce6df', // 1
            '#99ccbf', // 2
            '#66b39f', // 3
            '#33997f', // 4
            '#0F4735', // 5 (main brand color)
            '#0c382a', // 6
            '#092a20', // 7
            '#051d15', // 8
            '#020f0b', // 9 (darkest)
          ],
        },
      }}
    >
      <BrowserRouter>
        <AnalyticsListener />
        <AuthProvider>
          <Header />
          <Container size="xl">
            <Routes>
              {/* <Route path='/' element={<About />} /> */}
              <Route path='/' element={<App />} />
              <Route path='/about' element={<About />} />
              <Route path='/post/:postId' element={<PostPage />} />
              <Route path='/admin' element={<AuthLoader><AdminDashboard /></AuthLoader>} />
              <Route path='/login' element={<AuthLoader><Auth /></AuthLoader>} />
              <Route path='/privacy-policy' element={<PrivacyPolicy />} />
              <Route path='/terms-of-use' element={<TermsOfUse />} />
            </Routes>
          </Container>
          <Footer />
        </AuthProvider>
      </BrowserRouter>
    </MantineProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
